<template>
  <div class="validation_request_type">
    <div class="validation_request_type_head">
      <h4>{{type.display_name}}</h4>
      <!-- <p>
        Crée le {{type.created_at | moment-date}}</br>
        Mis à jour le {{type.updated_at | moment-date}}
      </p> -->
    </div>
    <p class="validation_request_type_description">
      {{type.description}}
    </p>

  </div>
</template>

<script>

export default {
  name:"ValidationRequestType",
  props:["type"],
}

</script>

<style scoped>
.validation_request_type {

}

.validation_request_type_head {

}

.validation_request_type_description {

}
</style>



// WEBPACK FOOTER //
// client/components/Demands/Details/Type.vue